import { render, staticRenderFns } from "./RecordQuery.vue?vue&type=template&id=25193e00&"
import script from "./RecordQuery.vue?vue&type=script&lang=js&"
export * from "./RecordQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports